import React from 'react';

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Checkbox from 'material-ui/Checkbox';
import Dialog from 'material-ui/Dialog';

import { execute } from 'store/configureStore';
import { transformAreaToPort } from 'sagas/regions/areas';
import _ from 'lodash';
import TransformAreaToPortDialog from './AreaToPortDialog';

class ManagementArea extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            areaName: '',
            openDialog: false,
            openDialogTransformArea: false,
            areaToPort: {
                coordinates: [0, 0],
                country: '',
                unLoCode: '',
            },
            areaToPortErrors: {},
            setAreaAsDefault: false,
        };

        this.onChangeName = this.onChangeName.bind(this);
        this.toggleOpenDialog = this.toggleOpenDialog.bind(this);
        this.toggleAreaAsDefault = this.toggleAreaAsDefault.bind(this);
    }

    toggleOpenDialog(key = 'openDialog') {
        this.setState({
            [key]: !this.state[key],
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.area) {
            if (!this.props.area) {
                this.setState({
                    areaName: nextProps.area.name,
                });

                return;
            }

            this.setState({
                areaName: nextProps.area.name,
            });
        }
    }

    toggleAreaAsDefault(value) {
        this.setState({
            setAreaAsDefault: value,
        }, () => {
            const { area } = this.props;
            area.setAreaAsDefault = this.state.setAreaAsDefault;
            this.props.onChangeArea(area);
        });
    }

    onChangeName(e, value) {
        this.setState({
            areaName: value,
            areaToPortErrors: {
                ...this.state.areaToPortErrors,
                name: '',
            },
        }, () => {
            const { area } = this.props;
            area.name = value;
            this.props.onChangeArea(area);
        });
    }

    handleChangeAreaToPort = (e, value, key) => {
        this.setState({
            areaToPort: {
                ...this.state.areaToPort,
                [key]: value,
            },
            areaToPortErrors: {
                ...this.state.areaToPortErrors,
                [key]: '',
            },
        });
    }

    isValidAreaToPort = () => {
        const { areaToPort, areaName } = this.state;
        const errors = {};

        if (!areaName) {
            errors.name = 'required';
        }

        if (!areaToPort.country) {
            errors.country = 'required';
        }

        if (!new RegExp(/^\-?\d+(\.\d+)?$/).test(`${areaToPort.coordinates[0]}`)) {
            errors.coordinates = 'wrong format';
        }

        if (!areaToPort.coordinates[0]) {
            errors.coordinates = 'required';
        }

        if (!new RegExp(/^\-?\d+(\.\d+)?$/).test(`${areaToPort.coordinates[1]}`)) {
            errors.coordinates = 'wrong format';
        }

        if (
            areaToPort.coordinates[0] && areaToPort.coordinates[1]
        && (
            areaToPort.coordinates[0] < -180 || areaToPort.coordinates[0] > 180
          || areaToPort.coordinates[1] < -90 || areaToPort.coordinates[1] > 90
        )
        ) {
            errors.coordinates = 'wrong format';
        }

        if (!areaToPort.coordinates[1]) {
            errors.coordinates = 'required';
        }

        // if (!areaToPort.unLoCode) {
        //   errors.unLoCode = 'required';
        // }

        if (Object.keys(errors).length) {
            this.setState({ areaToPortErrors: errors });

            return false;
        }

        return true;
    }

    transformAreaToPort = async () => {
        const {
            router,
            area: { _id: id = '' } = {},
        } = this.props;
        const { areaToPort, areaName } = this.state;

        if (!id) {
            return false;
        }

        if (!this.isValidAreaToPort()) {
            return false;
        }

        const response = await execute(transformAreaToPort, id, { ...areaToPort, name: areaName });

        if (response.status === 200) {
            this.toggleOpenDialog('openDialogTransformArea');
            router.push(`/regions/ports/${id}`);
        } else {
            const errors = {};

            response.errors.forEach((er) => {
                errors[er.field] = er.messages[0];
            });

            this.setState({ areaToPortErrors: errors });
        }
    }

    duplicateArea = () => {
        const { area, createNewArea, onChangeArea } = this.props;
        const areaCopy = _.cloneDeep(area);
        createNewArea();
        setTimeout(() => {
            onChangeArea({
                ...areaCopy,
                _id: undefined,
                isNew: true,
                name: `${areaCopy.name}_duplicate`,
            });
        }, 0);
    }

    render() {
        const {
            areaName, setAreaAsDefault, areaToPort, areaToPortErrors, 
        } = this.state;
        const {
            area,
            recalculateOnSave,
            recalculateMainPorts,
            portFromAutoComplete,
            toggleRecalculateChilds,
            toggleRecalculateMainPorts,
            createNewArea,
            createAreaOnServer,
            updateAreaOnServer,
            deleteAreaOnServer,
            showMarkersOnlyInThisArea,
            toggleShowMarkersOnlyInThisArea,
            changeMapView,
            showView,
            user,
            countries, 
        } = this.props;

        const isRestricted = area.mainRegion || area.isWWR;

        const actions = [
            <FlatButton
                label='Ok'
                primary
                onClick={() => { this.toggleOpenDialog(); deleteAreaOnServer(); }}
            />,
            <FlatButton
                label='Cancel'
                primary
                onClick={() => this.toggleOpenDialog()}
            />,
        ];

        let btnRender = (<RaisedButton
            label='save'
            primary
            disabled={areaName.length === 0}
            onClick={() => {
                createAreaOnServer({ setAreaAsDefault });
            }}
            style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
            buttonStyle={{ lineHeight: '25px', height: '25px' }}
            labelStyle={{ fontSize: '11px' }}
        />);

        if (area && !area.isNew) {
            btnRender = (
                <div>
                    <RaisedButton
                        label='update'
                        style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
                        buttonStyle={{ lineHeight: '25px', height: '25px' }}
                        labelStyle={{ fontSize: '11px' }}
                        onClick={() => {
                            updateAreaOnServer({ setAreaAsDefault });
                        }}
                        primary
                    />
                    {user.role === 'admin' && !isRestricted ? <RaisedButton
                        label='remove'
                        style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
                        buttonStyle={{ lineHeight: '25px', height: '25px' }}
                        labelStyle={{ fontSize: '11px' }}
                        onClick={() => this.toggleOpenDialog()}
                        secondary
                    /> : null}
                    {
                        area && area._id &&
                        <React.Fragment>
                            <RaisedButton
                                label='Area To Port'
                                onClick={() => this.toggleOpenDialog('openDialogTransformArea')}
                                style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
                                buttonStyle={{ lineHeight: '25px', height: '25px' }}
                                labelStyle={{ fontSize: '11px' }}
                            />
                            <RaisedButton
                                label='Duplicate area'
                                onClick={this.duplicateArea}
                                style={{ lineHeight: '25px', height: '25px' }}
                                buttonStyle={{ lineHeight: '25px', height: '25px' }}
                                labelStyle={{ fontSize: '11px', padding: '0 11px' }}
                            />
                        </React.Fragment>
                    }
                </div>);
        }

        return (
            <div className='paper-block margin-10' style={{ height: '102px' }}>
                <Dialog
                    title='Do you really want to delete area?'
                    actions={actions}
                    open={this.state.openDialog}
                    modal
                />
                <TransformAreaToPortDialog
                    open={this.state.openDialogTransformArea}
                    onClose={() => this.toggleOpenDialog('openDialogTransformArea')}
                    onSubmit={(data) => {
                        console.log('Form submitted with data:', data);
                        this.setState({
                            areaToPort: {
                                ...this.state.areaToPort,
                                coordinates: data.coordinates,
                                country: data.country,
                                unLoCode: data.unLoCode,
                            },
                            areaName: data.name,
                        }, () => {
                            this.transformAreaToPort();
                        });
                    }}
                    initialValues={{
                        name: areaName,
                        country: areaToPort.country,
                        unLoCode: areaToPort.unLoCode,
                        coordinates: [0, 0],
                    }}
                    countries={countries}
                />
                <span className='name-block absolute small-name'>Management</span>
                <div className='row'>
                    <div className='col-xs-3' style={{ position: 'relative' }}>
                        <TextField
                            ref='areaName'
                            floatingLabelText='Area name'
                            value={areaName}
                            onChange={this.onChangeName}
                            fullWidth
                            disabled={isRestricted}
                        />
                    </div>

                    <div className='col-xs-5 middle-xs'>
                        {btnRender}
                        <div style={{ display: 'flex', alignItems: 'center' }} >
                            <Checkbox
                                style={{ margin: '10px 0 0 0', fontSize: '12px', width: '46%' }}
                                checked={recalculateOnSave}
                                label='Recalculate area ports'
                                iconStyle={{ marginRight: '10px' }}
                                onCheck={(e, value) => {
                                    toggleRecalculateChilds(value);
                                }}
                            />
                            <Checkbox
                                style={{ margin: '10px 0 0 0', fontSize: '12px', width: '50%' }}
                                checked={recalculateMainPorts}
                                label='Recalculate main port ★'
                                iconStyle={{ marginRight: '10px' }}
                                onCheck={(e, value) => {
                                    toggleRecalculateMainPorts(value);
                                }}
                            />
                            {
                                area._id && !isRestricted &&
                                <RaisedButton
                                    label='Duplicate area'
                                    onClick={this.duplicateArea}
                                    style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
                                    buttonStyle={{ lineHeight: '25px', height: '25px' }}
                                    labelStyle={{ fontSize: '11px', padding: '0 11px' }}
                                />
                            }
                        </div>
                    </div>

                    <div className='col-xs-4 middle-xs'>
                        <div>
                            {
                                !isRestricted ? 
                                    <RaisedButton
                                        label={showView === 'map' ? 'merge' : 'map'}
                                        style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
                                        buttonStyle={{ lineHeight: '25px', height: '25px' }}
                                        labelStyle={{ fontSize: '11px' }}
                                        primary
                                        onClick={() => {
                                            if (showView === 'map') {
                                                changeMapView('merge');
                                            } else {
                                                changeMapView('map');
                                            }
                                        }}
                                    />
                                    : null
                            }

                            {area && portFromAutoComplete._id
                                ? <RaisedButton
                                    label='add port to region'
                                    style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
                                    buttonStyle={{ lineHeight: '25px', height: '25px' }}
                                    labelStyle={{ fontSize: '11px' }}
                                    onClick={this.props.addPortToRegion}
                                />
                                : null }

                            <RaisedButton
                                label='create new'
                                onClick={createNewArea}
                                style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
                                buttonStyle={{ lineHeight: '25px', height: '25px' }}
                                labelStyle={{ fontSize: '11px' }}
                            />
                            {
                                !isRestricted ?
                                    <RaisedButton
                                        label='create/update (by coords)'
                                        onClick={() => changeMapView('addByCoords')}
                                        secondary
                                        style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
                                        buttonStyle={{ lineHeight: '25px', height: '25px' }}
                                        labelStyle={{ fontSize: '11px' }}
                                    />
                                    : null
                            }

                        </div>
                        <div style={{ display: 'flex', gap: '5px' }}>
                            {area._id ? 
                                <Checkbox
                                    style={{ fontSize: '12px', display: 'flex', width: '69%' }}
                                    checked={showMarkersOnlyInThisArea}
                                    labelStyle={{ marginTop: '10px' }}
                                    iconStyle={{ marginRight: '10px', marginTop: '5px' }}
                                    label='Show markers only in this area'
                                    onCheck={(e, value) => {
                                        toggleShowMarkersOnlyInThisArea(value);
                                    }}
                                /> : null }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ManagementArea;



// WEBPACK FOOTER //
// ./app/components/Regions/Dashboard/Management.jsx